export default __webpack_public_path__ + "static/media/wip.a0e80ec9.png";